import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledLogo = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;

  img {
    display: flex;
    max-height: 68px;
    align-self: center;
  }
`;

export const YouProcessLogo = ({ src, companyName }) => (
  <StyledLogo>
    <img
      src={src}
      alt={companyName ? `${companyName} logo` : 'logo'}
      data-testid="process-dispatcher-logo"
    />
  </StyledLogo>
);

YouProcessLogo.propTypes = {
  src: PropTypes.string.isRequired,
  companyName: PropTypes.string,
};
